var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user === 'nxt' && _vm.user_is_nxt === true)?_c(_vm.tag,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):(_vm.user === 'classic' && _vm.user_is_nxt === false)?_c(_vm.tag,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }